import { createFileRoute } from "@tanstack/react-router";
import { validateChapterSearch } from "../../../../features/projects/chapterSearch";
import { ProjectPage } from "../../../../features/projects/ProjectPage";

export const Route = createFileRoute("/_app/projects/$projectId/")({
  validateSearch: validateChapterSearch,
  component: function Project() {
    const { projectId } = Route.useParams();
    const { chapter } = Route.useSearch();
    // Keyed by the project, so that another project opens on its own state, never on this one's draft.
    return <ProjectPage key={projectId} projectId={projectId} chapter={chapter} />;
  },
});
